<template>
  <div>
    <el-row>
      <el-col>
        <el-form v-model="searchForm" :ref="searchForm" :inline="true" style="margin-top: 20px">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="queryTableData">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="供应商" prop="BRAND"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.CURRENT_PRICE"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="submitPrice(scope.row)">提交</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryProductFun, submitPriceFun } from 'api/shopPrice';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
    };
  },
  methods: {
    // -----------------进入界面拉取功能---------搜索功能
    queryTableData() {
      const params = {
        PRODUCT_NAME: this.searchForm.name,
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      queryProductFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ------------------------------提交按钮
    submitPrice(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (!validation.价格正数0验证(row.CURRENT_PRICE)) {
            this.$message.show({ text: '请输入正数数字', type: 'error' });
            document.body.style.cursor = 'default';
            return false;
          }
          const params = {
            PROJECT_ID: Number(sessionStorage.getItem('projectId')),
            PRICE: Number(row.CURRENT_PRICE),
            TP_ID: Number(row.TP_ID),
          };
          submitPriceFun(params).then((result) => {
            this.$message.show({ text: '提交成功', type: 'success' });
            this.queryTableData();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.queryTableData();
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTableData();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTableData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/costCenter/soldPriceDetail.vue